import { Box, Button, HStack, Input, Text } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import SubTitle from './SubTitle';

interface ShippingInputProps {
  title?: string;
  name: string;
  phone: string;
  addressData: {
    zonecode: string;
    roadAddress: string;
    detailAddress: string;
    sido: string;
    sigungu: string;
    sigunguCode: string;
  };
  callBackName: (e: ChangeEvent<HTMLInputElement>) => void;
  callBackPhone: (e: ChangeEvent<HTMLInputElement>) => void;
  callBackSearchPostCode: () => void;
  callBackDetailAddress: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ShippingInput = (props: ShippingInputProps) => {
  const {
    title,
    name,
    phone,
    addressData,
    callBackName,
    callBackPhone,
    callBackSearchPostCode,
    callBackDetailAddress,
  } = props;
  return (
    <Box>
      {title && <SubTitle>{title}</SubTitle>}
      <Text fontSize={'13px'} fontWeight="semibold" mt={'16px'} mb={'8px'}>
        연락처
      </Text>
      <Input
        h="54px"
        fontSize={'1rem'}
        fontWeight="medium"
        focusBorderColor={'black'}
        borderRadius="base"
        borderColor="#eeeeee"
        _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
        maxLength={16}
        type="text"
        placeholder="이름"
        value={name}
        onChange={callBackName}
      />
      <Input
        h="54px"
        mt="8px"
        fontSize={'1rem'}
        fontWeight="medium"
        focusBorderColor={'black'}
        borderRadius="base"
        borderColor="#eeeeee"
        _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
        type="tel"
        placeholder="전화번호"
        value={phone}
        onChange={callBackPhone}
      />
      <Text fontSize={'13px'} fontWeight="semibold" mt={'24px'} mb="8px">
        배송주소
      </Text>
      <HStack mb="8px">
        <Input
          h="54px"
          fontSize={'1rem'}
          fontWeight="medium"
          bg="#fafafa"
          textColor={'#000'}
          borderColor="#ccc"
          borderRadius="base"
          _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
          type="text"
          disabled
          placeholder="우편번호"
          value={addressData?.zonecode}
        />
        <Button
          h="54px"
          fontSize={'0.875rem'}
          w="96px"
          fontWeight="semibold"
          borderRadius="base"
          colorScheme="black_button"
          onClick={callBackSearchPostCode}>
          <Text>주소검색</Text>
        </Button>
      </HStack>
      <Input
        h="54px"
        fontSize={'1rem'}
        fontWeight="medium"
        bg="#fafafa"
        textColor={'#000'}
        borderColor="#ccc"
        borderRadius="base"
        _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
        type="text"
        placeholder="기본주소"
        disabled
        mb="8px"
        value={addressData?.roadAddress}
      />
      <Input
        h="54px"
        fontSize={'1rem'}
        fontWeight="medium"
        focusBorderColor={'black'}
        borderColor={'#eee'}
        borderRadius="base"
        _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
        maxLength={50}
        type="text"
        placeholder="상세주소"
        value={addressData?.detailAddress}
        onChange={callBackDetailAddress}
      />
    </Box>
  );
};
export default ShippingInput;
